import { colors } from "../../Styles";

export function SiteList({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 284 284">
    <g transform="matrix(-1.05626,0,0,1.05626,261.778,-4.75317)">
        <path d="M206.734,249.047C206.734,252.547 200.047,259.234 196.547,259.234L32.753,259.234C29.253,259.234 22.566,252.547 22.566,249.047L22.566,28.353C22.566,24.853 29.253,18.166 32.753,18.166L196.547,18.166C200.047,18.166 206.734,24.853 206.734,28.353L206.734,121.489L220.4,121.419L220.4,29.3C220.4,15.6 209.3,4.5 195.6,4.5L33.7,4.5C20,4.5 8.9,15.6 8.9,29.3L8.9,248.1C8.9,261.8 20,272.9 33.7,272.9L195.6,272.9C209.3,272.9 220.4,261.8 220.4,248.1L220.4,190.325L206.734,190.325L206.734,249.047Z"/>
    </g>
    <g transform="matrix(1.28122,0,0,1.28122,-12.556,-61.3313)">
        <path d="M74.1,202.7L125.9,172.8L74.1,142.8L74.1,160.8L9.8,160.8L9.8,184.8L74.1,184.8L74.1,202.7Z"/>
    </g>
    <g transform="matrix(0.479834,-0.479834,0.479834,0.479834,76.8542,137.389)">
        <circle cx="210" cy="54.5" r="20.9"/>
    </g>
    <g transform="matrix(0.479834,-0.479834,0.479834,0.479834,76.8542,216.364)">
        <circle cx="210" cy="54.5" r="20.9"/>
    </g>
    <g transform="matrix(0.479834,-0.479834,0.479834,0.479834,76.8542,295.339)">
        <circle cx="210" cy="54.5" r="20.9"/>
    </g>
    <g transform="matrix(1.21188,0,0,1,-39.9075,8.275)">
        <rect x="112.6" y="49" width="62.3" height="11"/>
    </g>
    <g transform="matrix(0.486356,0,0,1,86.9863,5.26854)">
        <rect x="112.6" y="131.3" width="62.3" height="11"/>
    </g>
    <g transform="matrix(1.21188,0,0,1,-39.9075,2.275)">
        <rect x="112.6" y="212.5" width="62.3" height="11"/>
    </g>
    </svg>
  );
}
